
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1405Row.Fields;
    @Serenity.Decorators.registerClass()
    export class Report_1405Grid extends Serenity.EntityGrid<Report_1405Row, any> {
        protected getColumnsKey() { return Report_1405Columns.columnsKey; }
        protected getDialogType() { return Report_1405Dialog; }
        protected getIdProperty() { return Report_1405Row.idProperty; }
        protected getInsertPermission() { return Report_1405Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1405Row.localTextPrefix; }
        protected getService() { return Report_1405Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)

           let descriptions: string[] = [];
           let find :string= QRreport.QRywcSpecRow.getLookup().itemById["23"].SubCat1Code;
            
           let startDate = QRreport.QRywcSpecRow.getLookup().itemById["23"].DateBegin;
           let endDate = QRreport.QRywcSpecRow.getLookup().itemById["23"].DateEnd;
           let qstartDate = Q.formatDate(startDate, "dd/MM/yyyy")
           let qendDate = Q.formatDate(endDate, "dd/MM/yyyy")
           var a = ""
           
               a = "ระหว่างวันที่ " + qstartDate + " - " + qendDate

           
           var b = ""

           if (find != null) {
               let pos = Product.CsSubCategory1Row.getLookup().itemById[find].SubCat1Name;
               b = a + "  ระบุหมวดสินค้า2 " + find + " " + pos

           } else {

               b = a

           }
           descriptions.push(b);
            // if (request?.Criteria) {
            //     let criteria = request.Criteria.toString().split(',');
            //     let key: string = criteria[0];

            //     let n = columns.find(n => {
            //         return options.columnStyles[n]['field'] === key
            //     });
            //     if (n) {
            //         key = options.columnStyles[n]['title'];
            //     }

            //     let d1 = criteria.findIndex(c => c == ">=");
            //     if (d1 >= 0) {
            //         let v1 = criteria[d1 + 1];
            //         let d2 = criteria.findIndex(c => c == "<");
                    
            //         if (d2 >= 0) {
            //             let v2 = criteria[d2 + 1];
                        
            //             descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy"+' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy"+' (00:00)')}`);

            //         } else {
            //             descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
            //         }
            //     } else {
            //         let d2 = criteria.findIndex(c => c == "<");
            //         if (d2 >= 0) {
            //             let v2 = criteria[d2 + 1];
            //             descriptions.push(`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
            //         }
            //     }
            // } else {
            //     descriptions.push("วันที่ = ไม่ระบุ");
            // }

            

            // // console.log(request)
            // if (request?.EqualityFilter) {
            //     let quickFilters = this.getQuickFilters();

            //     let filters = Object.keys(request.EqualityFilter);

            //     for (let filterCol of filters) {
            //         let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
            //         let filterValue = request.EqualityFilter[filterCol];
            //         // if else{
            //         if (filterValue.length > 0) {
            //             if (Array.isArray(filterValue)) {
            //                 if (quickFilter.options.lookupKey) {
            //                     // console.log(filterValue);
            //                     (filterValue as any[]).forEach(value => {
            //                         var names: string[] = new Array(filterValue);
            //                         for (var i = 0; i < names.length; i++) {
            //                             filterValue = (names[i]);
            //                             console.log(filterValue);
            //                         }
            //                     })

            //                 }
            //             } else {
            //                 filterValue
            //             }
            //         }
            //         else {
            //             filterValue = "ไม่ระบุ"
            //         }
            //         // }

            //         let n = columns.find(n => {
            //             return options.columnStyles[n]['field'] === filterCol
            //         });
            //         if (n) {
            //             descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
            //         }
            //     }
            // }
            return [descriptions, gridColumns];
        }
        protected createQuickSearchInput() {
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups([""]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected markupReady() {
            super.markupReady();
    
            // expanding all level 0 (Country) and level 1 (City) groups initially
            // this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);
            
        }
     
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1405Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานสรุปยอดขายตามหมวดสินค้า-2(รวมร้านค้า)'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                // 0: { field: "ShopName", title: "ร้านค้า[Id]", cellWidth: 55 ,isHidden: true},
                0: { field: "SubCat1Code", title: "หมวดสินค้า -2", cellWidth: 30 ,isHidden:true},
                1: { field: "SubCat1Name", title: "หมวดสินค้า -2", cellWidth: 30 ,isHidden:true},
                // 3: { field: "ShopId", title: "ร้านค้า", cellWidth: 15 ,isHidden:true},
                // 4: { field: "CatCode", title: "หมวดสินค้า", cellWidth: 15 ,isHidden:true},
                2: { field: "DocDate", title: "วันที่", cellWidth: 57 },
                // 2: { field: "SubCat1Name", title: "หมวดย่อย1", cellWidth: 30,overflow:'linebreak' },
                // 3: { field: "SubCat2Name", title: "หมวดสินค้า-3", cellWidth: 30,overflow:'linebreak' },

                3: { field: "Qty", title: "จำนวน", cellWidth: 20,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                4: { field: "GrossSales", title: "ยอดขายก่อนลด", cellWidth: 40,halign: 'right',aggregate:"sum"},
                5: { field: "AllItemDiscount", title: "ยอดส่วนลดทั้งหมด", cellWidth: 40,halign: 'right',aggregate:"sum"},
                6: { field: "NetSales", title: "ยอดขายสุทธิ", cellWidth: 40, halign: 'right', aggregate: "sum" },
                7: { field: "NetSalesExVat", title: "ยข. สุทธิหักVAT", cellWidth: 40,halign: 'right',aggregate:"sum"},
                8: { field: "VatOfNetSales", title: "VAT(ยอดขาย)", cellWidth: 40,halign: 'right',aggregate:"sum"},
                // 9: { field: "AllItemCharge", title: "ค่าชาร์จ", cellWidth: 30,halign: 'right',aggregate:"sum"},
                // 10: { field: "VatOfCharge", title: "VAT(ค่าชาร์จ)", cellWidth: 30,halign: 'right',aggregate:"sum"},
            }

            // buttons.push(GeniuzPOS.Common.Helpers.Report1311PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.Report1311PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec1405/edit/23';
                        return false;
                    },
                }
            );

            return buttons;
        }
        
        // protected getQuickFilters() {
        //     var filters = super.getQuickFilters();

        //     Q.first(filters, x => x.field == fld.DocDate).init = w => {

        //         (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

        //         let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
        //         endDate.valueAsDate = new Date(Date.now());
        //     };
        //     return filters;
        // }
       

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            let ele = document.getElementsByClassName("grid-container");
            var bordermg = 60;
            var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            var totalcolw = 0;
           
            let propItems = this.getPropertyItems();
            let items = this.getColumns();
           items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                totalcolw += pItem.width;

            });
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                pItem.resizable = true;
                pItem.width = (eleWidth / totalcolw) * pItem.width;


            });
           
            let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            grid.setColumns(c);
            grid.resizeCanvas();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            
            this.view.setSummaryOptions({
                aggregators: [
                    
                    new Slick.Aggregators.Sum('GrossSales'),
                    new Slick.Aggregators.Sum('AllItemDiscount'),
                    new Slick.Aggregators.Sum('NetSales'),
                    new Slick.Aggregators.Sum('NetSalesExVat'),
                    new Slick.Aggregators.Sum('Qty'),
                    new Slick.Aggregators.Sum('VatOfNetSales'),
                   
                ]

            });
            
            return grid;
        }
    }
}